import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { editProductsApi, fetchProductVariantsApi } from 'api/products-api';
import { editProductVariantsApi } from 'api/product-variant-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  productVariants: [],
  statuses: [],
  products: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchProductVariantsListing = createAsyncThunk(
  'product-variants/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await fetchProductVariantsApi(paramsObj, '');
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

export const editProductVariant = createAsyncThunk(
  'product-variants/edit',
  async ({ id, updatedParamsObject = {}, signal = null }) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await editProductVariantsApi(id, paramsObj, signal);
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const ProductVariantsSlice = createSlice({
  name: 'productvariants',
  initialState,
  reducers: {
    setProductVariantsLoading: (state, { payload }) => {
      state.loading = payload?.loading;
    },
    setProductVariantsActiveColumn: (state, { payload }) => {
      state.activeColumns = payload?.activeColumns;
    },
    setProductVariantsData: (state, { payload }) => {
      state.productVariants = payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchProductVariantsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchProductVariantsListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.productVariants = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchProductVariantsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      })
      .addCase(editProductVariant.fulfilled, (state, action) => {
        if (action?.payload?.data?.id) {
          const updatedProductVariants = state.productVariants?.map((variant) => {
            if (variant?.id === action?.payload?.data?.id) {
              return action?.payload?.data;
            }
            return variant;
          });

          state.productVariants = [...updatedProductVariants];
        }
      });
  },
});

export const { setProductVariantsData, setProductVariantsLoading, setProductVariantsActiveColumn } =
  ProductVariantsSlice.actions;
export default ProductVariantsSlice.reducer;
